export default class API {
    public url(action: string, uri: string) {
        let url = `/api/dizest/${action}/${uri}`;
        return url;
    }

    public async call(action: string, uri: string, data: any = {}) {
        let url = `/api/dizest/${action}/${uri}`;
        try {
            const formData = new URLSearchParams();
            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    const val = data[key];
                    if (val === undefined) continue;
                    if (val === null) {
                        formData.append(key, '');
                    } else {
                        formData.append(key, typeof val === 'string' ? val : JSON.stringify(val));
                    }
                }
            }
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: formData.toString()
            });
            const res = await response.json();
            return { code: res.code, data: res.data };
        } catch (e) {
            return { code: 500, data: e };
        }
    }
}